<div class="row mx-0">
    <div
      class="col-12"
      style="
        background-color: #003b71;
        border-right: 2px solid #fff;
        border-left: 2px solid #fff;
      "
    >
      <img (click)="loginRoute()" src="../../assets/Images/header_full_96.jpg" class="logo" />
    </div>
  </div>